"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cache = void 0;
class Cache {
    constructor(store) {
        this.store = store;
    }
    cleanCache(key) {
        this.store.removeItem(key);
        this.store.removeItem(key + '_TTL');
    }
    setCached(key, result, cacheLiveTime) {
        this.store.setItem(key, result);
        const cacheExpires = new Date().getTime() + cacheLiveTime;
        this.store.setItem(key + '_TTL', cacheExpires);
    }
    getCached(key) {
        const cachedValue = this.store.getItem(key);
        if (cachedValue) {
            const cacheExpires = this.store.getItem(key + '_TTL') || 0;
            const actualTime = new Date().getTime();
            if (cacheExpires > actualTime) {
                return cachedValue;
            }
            this.cleanCache(key);
        }
        return null;
    }
}
exports.Cache = Cache;
//# sourceMappingURL=cache.js.map